<template>
  <div @click="visible = true">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-video-modal"
    >
      <div class="c-video">
        <video
          ref="video"
          controls
          preload="auto"
          x-webkit-airplay="allow"
          x5-video-player-fullscreen="true"
          x5-video-player-type="h5"
          x5-video-orientation="portraint"
        >
          <source :src="src" />
        </video>
        <div class="buttons">
          <md-button class="button" @click="onBack">
            {{ $t("back") }}
          </md-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "CVideo",
  props: {
    src: String,
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    video() {
      return this.$refs.video;
    },
  },
  methods: {
    onBack() {
      this.video.pause();
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-video {
  @include flex-center;
  width: 65vw;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  video {
    width: 100%;
    object-fit: fill;
    margin-bottom: 30px;
  }

  .buttons {
    @include flex-center;
    width: 100%;

    .button {
      width: 150px;
      height: 53px;
      background-color: $active-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }
}
</style>
